import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-flow-completion-confirmation",
  templateUrl: "./flow-completion-confirmation.component.html",
  styleUrls: ["./flow-completion-confirmation.component.scss"],
})
export class FlowCompletionConfirmationComponent implements OnInit {
  flowData: any;
  userData: any;
  contentType: "flow" | "bundle" = "flow";

  constructor(
    public dialogRef: MatDialogRef<FlowCompletionConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {
    this.flowData = data.flowData;
    this.contentType = data?.contentType === "bundle" ? "bundle" : "flow";
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
  }

  get contentTypeLabel(): string {
    return this.contentType === "bundle" ? "bundle" : "flow";
  }

  get completionHeading(): string {
    return this.contentType === "bundle" ? "Bundle completion" : "Flow completion";
  }

  ngOnInit() {
    if (!this.userData) {
      this.dialogRef.close({ completed: false });
      this.router.navigate(["/registration"]);
    }
  }

  onYes() {
    this.dialogRef.close({ completed: true });
  }

  onNo() {
    this.dialogRef.close({ completed: false });
  }

  onStuck() {
    this.dialogRef.close({ completed: false, stuck: true });
  }

  close() {
    this.dialogRef.close({ completed: false });
  }
}


